export const GET_EXCHANGE_RATE = 'GET_EXCHANGE_RATE';
export const GET_EXCHANGE_RATES = 'GET_EXCHANGE_RATES';
export const ADD_EXCHANGE_RATE = 'ADD_EXCHANGE_RATE';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
